import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useBreakPenalty } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { SwitchInput } from "@sinch/components/form/SwitchInput/SwitchInput";

/**
 * Switch that lets the penalty length be set to something else than the required break length
 */
export const CustomPenaltyLengthField: FC = () => {
  const { t } = useTranslation();
  const { disabled, customPenalty, setCustomPenalty } = useBreakPenalty();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setCustomPenalty(checked),
    [setCustomPenalty]
  );

  return (
    <SwitchInput
      disabled={disabled}
      helperText={t("RateUnit.breakPenaltyCustomLengthHint")}
      label={t("RateUnit.breakPenaltyCustomLength")}
      onChange={handleChange}
      value={customPenalty}
    />
  );
};
